<template>
  <div data-test="forgot-password-form">
    <el-collapse-transition>
      <div>
        <el-link @click="handleCancel" style="margin-top: 20px;" type="danger">
          {{ $t('userSignInForm.cancelForgotPassword') }}
        </el-link>
        <el-form
          ref="form" :rules="rules" :model="form"
          @submit.prevent.native="submit">
          <el-form-item prop="password" :label="$t('resetPasswordForm.passwordLabel')">
            <el-input
              data-test="pass-form-input__password"
              v-model="form.password"
              type="password"
              :placeholder="$t('resetPasswordForm.passwordLabel')">
            </el-input>
          </el-form-item>
          <el-form-item
            prop="confirmation" :label="$t('resetPasswordForm.passwordConfirmationLabel')">
            <el-input
              data-test="pass-form-input__confirmation"
              v-model="form.confirmation"
              type="password"
              :placeholder="$t('resetPasswordForm.passwordConfirmationLabel')">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              v-loading="loading"
              data-test="submit-button"
              type="success" style="width: 100%;"
              @click="submit">
              {{ $t('resetPasswordForm.submitButtonText') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import validatePasswordMixin from '@/mixins/validatePassword';

export default {
  mixins: [validatePasswordMixin],
  data() {
    return {
      loading: false,
      showForgotPassword: false,
      rules: {
        password: [
          {
            required: true,
            message: this.$t('resetPasswordForm.wrongPasswordFormatMessage'),
            trigger: ['blur', 'change'],
            validator: this.$passwordValidator,
          },
        ],
        confirmation: [
          {
            required: true,
            message: this.$t('resetPasswordForm.wrongConfirmationMessage'),
            trigger: ['blur', 'change'],
            validator: this.$passwordConfirmValidator,
          },
        ],
      },
      form: {
        password: '',
        confirmation: '',
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit('canceled');
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) { return; }
        this.$emit('submited', this.form);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
